export function getDisplayPrice(product) {
  const dp = product?.discounted_price;
  const original = parseFloat(product?.package_price || product?.price || 0);
  const hasDiscount = dp !== null && dp !== undefined && dp !== '' && parseFloat(dp) !== original;
  const discounted = hasDiscount ? parseFloat(dp) : null;
  const isFree = (hasDiscount && discounted === 0) || (!hasDiscount && original === 0);
  return { original, discounted, hasDiscount: hasDiscount && original > 0, isFree };
}
